/**
 * Created by stonewang on 2018/2/19.
 */
import React from 'react';
import Reflux from 'reflux';
import {
  hashHistory,
  withRouter,
} from 'react-router';
import {
  Checkbox,
  Button,
  Pagination,
  message,
  Spin,
} from 'antd';
// import { favorites, deleteFavorites } from '../../service/mall/collect';
import {
  getShoppingCarList,
  deleteShoppingCarList,
} from '../../service/favorites';
import {
  CollectActions,
  CollectStore,
} from './store';
import {
  returnFloat,
  config,
} from 'Utils';
import { isShowInventory } from '../../service/mall';

class Collection extends Reflux.Component {
  constructor(props) {
    super(props);
    this.store = Reflux.initStore(CollectStore);
    let obj = this.store.state.useStore ? this.store.state.params : null;
    const currentChannel = window.sessionStorage.getItem('cur_channel') || '';
    this.channelCode = currentChannel.split('|')[1] || '';
    this.state = {
      editFlag: false,
      total: 0,
      list: [],
      loading: false,
      productIdList: [],
      searchObj: {
        p: 1,
        s: 10,
        isFlag: 1, // 查询有商品ID的收藏记录， 不传这个字段查所有收藏信息
        active: '',
        category: [],
        channelCode: this.channelCode,
        name: '',
        ...obj,
      },
      showHideId: '',
      checkIds: [],
      checkedAll: 0,
      isShow: true, //显示库存
      zeroAdd: true, //0库存下单
    };
    this.goView = this.goView.bind(this);
    this.getData = this.getData.bind(this);
    this.cancelAll = this.cancelAll.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
    this.cancelCollection = this.cancelCollection.bind(this);
    this.isShowInventory = this.isShowInventory.bind(this);
  }

  //离开当前路由时，更新store
  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname; //.split('/');
    if (/productDetail/.test(path)) { //当下一个路由是详情页时，将useStore的值设为true
      CollectActions.updateState({ useStore: true });
      CollectActions.paramChange(this.state.searchObj);
    } else {
      CollectActions.updateState({ useStore: false, params: {} });
    }
  }

  componentDidMount() {
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    this.isShowInventory();
  }

  isShowInventory() {
    isShowInventory().then((result) => {
      if (result && result.status) {//{show_inventory: "N", allow_reservation: "Y"}
        var isShowInventory = result.data;
        if (isShowInventory.show_inventory && isShowInventory.show_inventory == 'N') {
          this.setState({
            isShow: false,
          });
        } else {
          this.setState({
            isShow: true,
          });
        }
        if (isShowInventory.allow_reservation && isShowInventory.allow_reservation == 'N') {
          this.setState({
            zeroAdd: false,
          });
        } else {
          this.setState({
            zeroAdd: true,
          });
        }
      } else {
        message.error(result.message);
      }
    });
  }

  getData() {
    this.setState({ loading: true });
    getShoppingCarList(this.state.searchObj).then(res => {
      this.setState({ loading: false });
      if (res.status) {
        this.setState({ list: res.data, total: res.total });
      }
    });
  }

  pageChange(page, s) {
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        s: s,
        p: page,
      },
    }, () => {
      this.getData();
    });
  }

  goView(url) {
    hashHistory.push(url);
  }

  showHideBtn(id) {
    this.setState({
      'showHideId': id,
    });
  }

  //取消收藏
  cancelCollection(commodityId, productId) {
    var collectionId = [];
    collectionId.push({ productId, commodityId });
    deleteShoppingCarList(collectionId).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && this.getData();
    });
  }

  //批量取消收藏
  cancelAll() {
    const { productIdList } = this.state;
    if (productIdList.length > 0) {
      deleteShoppingCarList(productIdList).then(res => {
        message[res.status ? 'success' : 'error'](res.message);
        res.status && this.getData();
      });
    } else {
      message.info('请选择商品');
    }
  }

  checkFn({ id, productId, commodityId }) {
    let { productIdList, checkIds } = this.state;
    let cIndex = checkIds.findIndex(x => x === id);
    let pIndex = productIdList.findIndex(x => x.productId === productId);
    if (cIndex > -1) {
      checkIds.splice(cIndex, 1);
    } else {
      checkIds.push(id);
    }
    if (pIndex > -1) {
      productIdList.splice(pIndex, 1);
    } else {
      productIdList.push({ productId, commodityId });
    }
    this.setState({
      ...this.state,
      checkIds,
      productIdList,
      checkedAll: checkIds.length === this.state.list.length,
    });
  }

  checkAllFn() {
    const { checkedAll, list } = this.state;
    let checkIds = [];
    let productIdList = [];
    if (!checkedAll) {
      list.forEach(item => {
        checkIds.push(item.id);
        productIdList.push({ productId: item.productId, commodityId: item.commodityId });
      });
    }
    this.setState({
      ...this.state,
      checkIds,
      productIdList,
      checkedAll: !checkedAll,
    });
  }

  notGo() {
    message.info('该产品已下架');
    return;
  }

  render() {
    const self = this;
    const { list, total, searchObj, loading, showHideId, checkIds, checkedAll, isShow, zeroAdd } = this.state;
    const pagination = {
      total: total,
      pageSize: searchObj.s,
      current: searchObj.p,
      pageSizeOptions: ['1', '10', '20', '30', '40'],
      showTotal: total => `共 ${total} 条`,
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: self.pageChange.bind(self),
      onChange: self.pageChange.bind(self),
      size: 'small',
    };
    if (list.length) {
      return <Spin spinning={loading}>
        <div className="collection-box">
          <div className="btn">
            <Checkbox checked={checkedAll} onChange={self.checkAllFn.bind(self)}>全选</Checkbox>
            <Button type="primary" onClick={this.cancelAll}>批量取消收藏</Button>
          </div>
          <div className="list">
            <div className='goods-list clear'>
              {list.map((item, index) => <dl key={index} onMouseOver={self.showHideBtn.bind(self, item.id)}
                                             onMouseOut={self.showHideBtn.bind(self, '')}>
                <dt>
                  {
                    item.productNum == 0 && !zeroAdd && (item.isExist == 1) &&
                    <i className="dmsIcon dmsSoldOut"></i>
                  }
                  {
                    (item.active == 0 || item.isExist == 0) &&
                    <i className="dmsIcon dmsDropOff"></i>
                  }
                  <img src={item.imgUrl ? `${config.server}/${item.imgUrl}` : require('../../assets/images/product-default.png')}
                       alt="" />
                  <span className="check">
                    <Checkbox checked={checkIds.indexOf(item.id) > -1}
                              onChange={self.checkFn.bind(self, item)} />
                  </span>
                </dt>
                <dd>
                  <div>{item.productName}</div>
                  <p>
                    <span>{returnFloat(item.promotionPrice)}</span>
                    {
                      item.showPrice > item.promotionPrice && item.promotionCount > 0 &&
                      <span style={{
                        fontSize: '12px',
                        color: '#777',
                        textDecoration: 'line-through',
                        paddingLeft: '10px',
                        float: 'left',
                      }}>{returnFloat(item.showPrice)}</span>
                    }
                    {/*{
                      isShow &&
                      <span style={{
                        float: 'right',
                        fontSize: '12px',
                      }}>库存{item.productNum}</span>
                    }
                    {
                      (!isShow && !zeroAdd) && item.productNum > 0 &&
                      <span style={{ float: 'right', fontSize: '12px' }}>有货</span>
                    }
                    {
                      (!isShow && !zeroAdd) && !(item.productNum > 0) &&
                      <span style={{ float: 'right', fontSize: '12px' }}>缺货</span>
                    }*/}
                  </p>
                </dd>
                <dd className="btn" style={{ height: showHideId == item.id ? '68px' : 0 }}>
                  {
                    !(item.active == 0 || item.isExist == 0) ?
                      <a href="javascript:void(0);"
                         onClick={() => self.goView(item.commodityId ? `/mallCommon/productDetail/${item.commodityId}/${item.productId}` : `/product/${item.productId}`)}>查看</a>
                      :
                      <a href="javascript:void(0);"
                         onClick={self.notGo.bind(self, item)}>查看</a>
                  }
                  <a onClick={this.cancelCollection.bind(this, item.commodityId, item.productId)} href="javascript:void(0);"
                     className="right">取消收藏</a>
                </dd>
              </dl>)}
            </div>
            <div className="paginationBox">
              <Pagination {...pagination} />
            </div>
          </div>
        </div>
      </Spin>;
    }
    return <Spin spinning={loading}>
      <div className="cusNoDataBig">暂无数据</div>
    </Spin>;
  }
}

export default withRouter(Collection);



// WEBPACK FOOTER //
// ./src/mall/userCenter/collection.js